import styled from "styled-components";

export default styled.div`
    .formGrid {
        display: grid;
        grid-template-columns: repeat(3, 1fr);
        gap: 20px;
        align-items: start;

        &.compact {
            gap: 10px;
            margin-bottom: 20px;
        }

        > div {
            display: flex;
            flex-direction: column;

            label {
                font-size: 12px;
                font-weight: 600;
                letter-spacing: 1px;
                color: ${(props) => props.theme.textSecondary};
                margin-bottom: 8px;
            }

            > div {
                margin: 0;
            }

            .labelWithStatus {
                display: flex;
                align-items: center;
                gap: 10px;
                margin-bottom: 8px;

                label {
                    margin-bottom: 0;
                }

                .bbgStatus {
                    display: flex;
                    align-items: center;
                    gap: 5px;
                    font-size: 11px;
                    font-weight: 500;

                    &.loading {
                        color: ${(props) => props.theme.primary};
                    }

                    &.success {
                        color: #4caf50;
                    }

                    &.error {
                        color: #f44336;
                    }
                }
            }

            .labelWithEdit {
                display: flex;
                align-items: center;
                gap: 10px;
                margin-bottom: 8px;

                label {
                    margin-bottom: 0;
                }
            }
        }

        .twoColumns {
            grid-column: span 2;
        }

        .checkboxGrid {
            display: grid;
            grid-template-columns: repeat(3, 1fr);
            gap: 0;

            .checkboxField {
                height: auto;

                .MuiCheckbox-root {
                    padding: 4px;
                }
            }
        }

        .checkboxField {
            display: flex;
            align-items: center;
            gap: 8px;

            label {
                margin-bottom: 0;
                cursor: pointer;
                user-select: none;
            }
        }
    }

    .dynamicFieldsContainer {
        display: grid;
        grid-template-columns: 1fr 1fr;
        gap: 15px;
        margin-top: 20px;

        .sectionHeader {
            display: flex;
            justify-content: flex-start;
            align-items: center;
            gap: 16px;
            margin-bottom: 10px;
            grid-column: 1 / -1;

            label:not(.btnText) {
                font-size: 13px;
                font-weight: 600;
                letter-spacing: 1px;
                color: ${(props) => props.theme.textPrimary};
                margin-bottom: 0;
            }
        }

        .dynamicFieldSection {
            display: flex;
            flex-direction: column;
            gap: 10px;
            padding: 15px 15px 15px 0;
            background-color: ${(props) => props.theme.backgroundSecondary};
            border-radius: 5px;
            margin-bottom: 10px;

            &:first-child {
                grid-column: 1 / -1;
            }

            .sectionHeader {
                display: flex;
                justify-content: space-between;
                align-items: center;
                margin-bottom: 10px;

                label {
                    font-size: 13px;
                    font-weight: 600;
                    letter-spacing: 1px;
                    color: ${(props) => props.theme.textPrimary};
                    margin-bottom: 0;
                }

                .tooltipLabel {
                    display: flex;
                    align-items: center;
                    gap: 8px;
                }

                .sectionError {
                    color: lightcoral;
                    font-size: 12px;
                    font-weight: normal;
                }
            }

            .dynamicFieldRow {
                display: flex;
                gap: 10px;
                align-items: center;

                .selectField {
                    flex: 1;

                    > div {
                        margin: 0;
                    }
                }

                .percentageField {
                    flex: 0 0 130px;

                    > div,
                    .textField,
                    .textField input {
                        margin-bottom: 0;
                        width: 130px;
                    }
                }

                .button {
                    min-width: 40px;
                    flex-shrink: 0;
                }

                .deleteAction {
                    &.hidden {
                        visibility: hidden;
                    }
                }

                &.linkRow {
                    display: grid;
                    grid-template-columns: 1fr 2fr;
                    gap: 10px;
                    align-items: start;

                    .linkTypeField .MuiAutocomplete-root {
                        width: 100%;

                        .MuiInputBase-root {
                            box-sizing: border-box;
                            background: #eeeeee;
                            border-radius: 5px;
                            height: 40px;
                            padding: 0 8px 0 0 !important;
                            font-family: Calibri, HelveticaNeue, Arial,
                                sans-serif;

                            input {
                                padding: 0 15px !important;
                                font-size: 18px;
                                height: 40px;
                                color: inherit;
                                font-family: inherit;

                                &::placeholder {
                                    color: #777777;
                                    opacity: 1;
                                }
                            }

                            .MuiAutocomplete-endAdornment {
                                right: 8px;
                            }

                            fieldset {
                                border: none;
                            }

                            &:hover,
                            &.Mui-focused {
                                background: #dddddd;
                            }
                        }

                        .MuiFormHelperText-root {
                            margin: 4px 0 0 0;
                            font-size: 10px;
                            color: ${(props) => props.theme.primary};
                            font-style: italic;
                        }
                    }

                    .urlField {
                        display: flex;
                        align-items: flex-start;
                        gap: 10px;

                        > div:first-child {
                            flex: 1;
                            margin: 0;
                        }

                        .deleteBtn {
                            flex-shrink: 0;
                            height: 40px;
                            display: flex;
                            align-items: center;
                        }
                    }
                }
            }

            &.customCategorySection {
                .dynamicFieldRow.customCategoryRow {
                    align-items: flex-start;

                    .customItemField {
                        flex: 1;

                        .MuiAutocomplete-root {
                            width: 100%;

                            .MuiInputBase-root {
                                background: #eeeeee;
                                border-radius: 5px;
                                height: 40px;
                                padding: 0 8px 0 0 !important;

                                input {
                                    padding: 0 15px !important;
                                    height: 40px;
                                    color: inherit;

                                    &::placeholder {
                                        color: #777777;
                                        opacity: 1;
                                    }
                                }

                                .MuiAutocomplete-endAdornment {
                                    right: 8px;
                                }

                                fieldset {
                                    border: none;
                                }

                                &:hover,
                                &.Mui-focused {
                                    background: #dddddd;
                                }
                            }

                            .MuiFormHelperText-root {
                                margin: 4px 0 0 0;
                                font-size: 10px;
                                color: ${(props) => props.theme.primary};
                                font-style: italic;
                            }
                        }
                    }

                    .deleteAction {
                        flex-shrink: 0;
                        height: 40px;
                        display: flex;
                        align-items: center;

                        &.hidden {
                            visibility: hidden;
                        }
                    }
                }
            }

            .categoryNameMeta {
                flex: 0 0 130px;
                height: 40px;
                display: flex;
                align-items: center;
                gap: 8px;

                label {
                    font-size: 13px;
                    line-height: 1;
                    margin: 0;
                }

                .sectionError {
                    color: lightcoral;
                    font-size: 12px;
                }
            }

            .customCategoryNameRow .customItemField input {
                font-weight: 600;
            }

            .categoryAddItemRow {
                padding-top: 4px;
            }
        }


    }
`;
